var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageUrl)?_c('ImagePreview',{staticClass:"image-preview-size",attrs:{"src":_vm.imageUrl,"height":"100%","alt":"Image","preview":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }